import { forwardRef } from "react";
import * as LabelPrimitive from "@radix-ui/react-label";
import { cn } from "@/lib/utils";

export interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  required?: boolean;
}

export const Label = forwardRef<React.ElementRef<typeof LabelPrimitive.Root>, LabelProps>(
  ({ className, required, children, ...props }, ref) => (
    <LabelPrimitive.Root
      ref={ref}
      className={cn(
        "block text-sm font-semibold text-foreground/90 select-none",
        className,
      )}
      {...props}
    >
      {children}
      {required ? <span className="ml-1 text-destructive">*</span> : null}
    </LabelPrimitive.Root>
  ),
);
Label.displayName = "Label";
